import React, {useState} from "react";
import Styles from './styles.module.scss';
// import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
// import {scroller} from "react-scroll";
// import {pageScrollHandler} from "../../helpers/pageScrollHandler";
// import {useDispatch} from "react-redux";
// import {setLinkScrollStatus} from "../../store/main/action";
import LangSwitcher from "../langSwitcher";


const PublicNavigation = () => {
    // const dispatch = useDispatch();
    // const navigate = useNavigate();
    const { t } = useTranslation();

    const [mobileNavStatus, setMobileNavStatus] = useState(false);

    // const navigateHandler = (page) =>{
    //     navigate(page);
    //     setMobileNavStatus(false);
    // }

    // const scrollHandler = (element) =>{
    //     scroller.scrollTo(element, {
    //         duration: 800,
    //         delay: 0,
    //         smooth: 'easeInOutQuart'
    //     })
    // }

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap}`}>
                <div
                    className={`${Styles.mobileBtn} ${mobileNavStatus ? Styles.mobileBtnActive : null}`}
                    onClick={()=>{setMobileNavStatus(!mobileNavStatus)}}
                >
                    <div/>
                    <div/>
                    <div/>
                </div>
                <div className={`${Styles.navWrap} ${mobileNavStatus ? Styles.navWrapActive : null}`}>
                    <div className={`${Styles.navItem}`} onClick={() => window.location.assign(`${process.env.REACT_APP_NEXT_LINK}/`)}>{t('Главная')}</div>
                    <div className={`${Styles.navItem}`} onClick={() => window.location.assign(`${process.env.REACT_APP_NEXT_LINK}/`)}>{t('Идеология')}</div>
                    <div className={`${Styles.navItem}`} onClick={() => window.location.assign(`${process.env.REACT_APP_NEXT_LINK}/how-it-works`)}>{t('Крипта для народа')}</div>
                    <LangSwitcher isPublicStyle={true}/>
                </div>
            </div>
        </section>
    );
};

export default PublicNavigation;
